import { isDefined } from '@sgme/fp';
import { useAppSelector } from 'hooks/useAppSelector';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Navigate } from 'react-router-dom';
import { getUserPreferencesLandingPage } from 'state/selectors';

export const LoadingUserPreferences: FC = () => {
  const landingPage = useAppSelector(getUserPreferencesLandingPage);
  if (isDefined(landingPage)) {
    return <Navigate to="/" />;
  }
  return (
    <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
      <div className="spinner-border mb-2"></div>
      <FormattedMessage id="userPreferencesForm.loading" defaultMessage="Loading user preferences..." tagName="span" />
    </div>
  );
};
